export default {
  containerVisitas: {
    semVisitas: 'Sem visitas em 14 dias',
    visitasAgendadas: 'Visitas agendadas',
    visitasRealizadas: 'Visitas realizadas'
  }
};
